import React from 'react';
import { Box, Typography, Button, Paper, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface DealDetailsCardProps {
  dealData: any; // Using 'any' for now based on the provided JSON structure
}

const DealDetailsCard: React.FC<DealDetailsCardProps> = ({ dealData }) => {
  const navigate = useNavigate();

  const handleOpenDeal = () => {
    if (dealData?.deal?.id) {
      navigate(`/deals/${dealData.deal.id}`);
    }
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 , mt: 3}}>
        <Typography variant="h6">Deal Details</Typography>
        <Button
          variant="contained"
          onClick={handleOpenDeal}
          disabled={!dealData.deal?.id}
        >
          Open Deal
        </Button>
      </Box>
      <Paper component={Box} variant="outlined" sx={{ p: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="text.secondary">Deal Name:</Typography>
            <Typography variant="body1">{dealData.deal?.name || 'N/A'}</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="text.secondary">Deal Type:</Typography>
            <Typography variant="body1">{dealData.deal?.deal_type || '-'}</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="text.secondary">Company:</Typography>
            <Typography variant="body1">{dealData.deal?.company || '-'}</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="text.secondary">Industry:</Typography>
            <Typography variant="body1">{dealData.deal?.industry || '-'}</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="text.secondary">Region:</Typography>
            <Typography variant="body1">{dealData.deal?.region || '-'}</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="text.secondary">Status:</Typography>
            <Typography variant="body1">{dealData.deal?.status || '-'}</Typography>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default DealDetailsCard;